import React from 'react';
import { Link } from 'react-router-dom'

export default function Msshruti(){
		const style = {
  fontFamily: 'revert',
  fontSize: '15px',
  color: '#000',
  fontWeight: 'bolder'
};
  return (
     <div>
     {/* Header Start */}
	  <div className="container-fluid hero-header bg-light py5 mb-5"  style={{"padding-top":"1rem !important","padding-bottom":"1rem !important"}}>
		<div className="container py-5">
		  <div className="row g-5 align-items-center">
			<div className="col-lg-6">
			  <h1 className="display-4 mb3 animated slideInDown">Profile</h1>
			  <nav aria-label="breadcrumb animated slideInDown">
				<ol className="breadcrumb mb-0">
				  <li className="breadcrumb-item"><Link to="/">Home</Link></li>
				  <li className="breadcrumb-item active" aria-current="page">Profile</li>
				</ol>
			  </nav>
			</div>
			
			
		  </div>
		</div>
	  </div>
	  {/* Header End */}
	  {/* About Start */}
	  <div className="container-xxl">
		<div className="container">
		  <div className="row g-5 align-items-center">
			<div className="vission-text">
			<h1 className="display-6">Ms. Shruti Sethi (Non-Executive-Independent Director)</h1>
			<p style={{ textAlign: 'justify', color: 'black' }}>Ms. Shruti Sethi is a qualified Company Secretary and a commerce graduate, pursuing LL.B and registered Independent Director with the Independent Directors' Databank. She possesses over four years of professional experience in corporate laws, secretarial compliances, corporate governance, and regulatory affairs. She is associated with Wind World Wind Farms (Karnataka) Limited as Executive Company Secretary.</p>
			<p style={{ textAlign: 'justify', color: 'black' }}>Ms. Sethi has actively participated in various professional seminars, webinars, and knowledge initiatives conducted by the Institute of Company Secretaries of India (ICSI) and has developed sound expertise in the Companies Act, 2013, SEBI (LODR) Regulations, SEBI (ICDR) Regulations, and allied corporate laws. Her professional knowledge, compliance expertise, and commitment to ethical corporate governance make her well-suited to discharge the responsibilities of an Independent Director.</p>
				 <h2 style={{ fontFamily: 'revert', fontSize: '15px', color: '#000', fontWeight: 'bolder' }}>
					She has Directorship in the following Companies:
				  </h2>
				  <table style={style} className="table table-bordered table-striped">
					<thead>
					  <tr>
						<th width="20" className="text-center">Sr.no</th>
						<th className="text-left">Name of company</th>
						<th>Designation</th>
					  </tr>
					</thead>
					<tbody>
					  <tr>
						<td className="text-center">1</td>
						<td>KALPA COMMERCIAL LIMITED</td>
						<td width="280" className="text-center">Non-Executive-Independent Director</td>
					  </tr>
					</tbody>
				  </table>


		</div>
		
		  </div>
		</div>
	  </div>
	  {/* About End */}
	</div>
    );
}